/* eslint-disable react/no-array-index-key */

import styled from 'styled-components';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import { Typography } from 'components/generic/typography';
import FilterListItem from 'components/List/components/FilterListItem';
import { findNSelectedOptions } from '../shared/helpers';
import type { RootDefaultMenuItemType } from '../shared/types';

const PreviewText = styled(Typography.Body)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 50%;
`;

export default function RootDefaultFilterMenuItem({ model }: { model: RootDefaultMenuItemType }) {
    const {
        displayName,
        options,
        attribute: { id }
    } = model;
    const filterMenuId = id.toString();
    const { toggle } = useDrawer(filterMenuId);
    const selectedOptions = findNSelectedOptions(options, 8).map((option) => option.displayName);

    const selectedOptionsPreviewText = !!selectedOptions.length && (
        <PreviewText forwardedAs="span" size="S" strong>
            {selectedOptions.join(', ')}
        </PreviewText>
    );

    return (
        <FilterListItem.Button
            type="navigation"
            selectedPreview={selectedOptionsPreviewText}
            buttonProps={{ onClick: toggle }}
        >
            {displayName}
        </FilterListItem.Button>
    );
}
